module.exports = __webpack_public_path__ + "images/2b8a837.png";